<template>
    <div name="duplicate-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose()">

            </div>
            <div class="contents">
                <span class="title">신규 등록 불가 안내</span>
                <span style="margin-top: 35px;" class="text1">환자 정보: <span style="color:#184FA1">{{ name }}</span></span>
                <span class="text2" style="margin-top: 20px;">
                    해당 환자는 다른 카카오 계정에서 등록된 이력이 있어요. <br>본인 또는 가족이 다른 계정으로 등록하셨을 수 있으니 확인 후 진행해 주세요.  <br><br>
                <span class="text2">* 계정 확인이 어렵거나 등록 여부가 확실하지 않은 경우 고객센터로 문의해 주세요.</span></span>
                <div class="button2" style="margin-top: 38px;" @click="onCloseAndCs">고객센터 문의</div>
                <div class="button1" @click="onClose">홈으로 이동</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'duplicateModal',
    props: ['name'],
    methods: {
        onClose: function()
        {
            this.$emit('onClose')
        },
        onCloseAndCs: function()
        {
            this.$emit('onCloseAndCs')
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;
    }

    @media (min-width: 600px) {
        .modal {
            width: 600px;
        }
    }

    .touch {
        height: calc(100vh - 482px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 482px;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 32px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }

    .text1 {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 120% */
    }
    .text2 {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 120% */
    }
    .description {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 120% */
        margin-top: 25px;
    }

    .button1 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: #FFF;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .button2 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .button-row {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 16px 0 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/GlobalDuplicateModal.vue